import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label, Button } from 'react-bootstrap';
import moment from 'moment';
import classnames from 'classnames';
import { titleize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
import CargomaticCard from 'components/v2/card';
import CommentList from 'components/modules/comments/CommentList';
import { withTranslation } from 'react-i18next';
import HeadingDivider from './HeadingDivider';
import ShipmentsActionCreators from '../../../actions/ShipmentsActionCreators';
import ExceptionsActionCreators from '../../../actions/ExceptionsActionCreators';
import AddAccessorialModal from '../shipments/accounting/AddAccessorialModal';
import ShipmentWindowChange from '../../ui/modals/ShipmentWindowChange';
import ShipmentStore from '../../../stores/ShipmentStore';
import SessionStore from '../../../stores/SessionStore';
class ShipmentDetails extends React.Component {
    constructor(props) {
        super(props);
        this.getRefreshedShipment = () => {
            ShipmentStore.getShipment(this.props.shipment._id);
        };
        this.handleAddAccessorial = (shipment, key, meta) => {
            ShipmentsActionCreators.addAccessorial(shipment, key, meta);
        };
        this.handleRemoveAccessorial = (shipment, key) => {
            ShipmentsActionCreators.removeAccessorial(shipment, key);
        };
        this.handleAccessorialError = () => {
            const error = ShipmentStore.getAddAccessorialError();
            this.setState({
                accessorialError: error ? { error } : null,
            });
        };
        this.handleChange = () => {
            const exceptionShipment = ShipmentStore.getShipment(this.props.shipment._id);
            const exception = Object.assign({}, this.state.exception);
            exception.shipment = exceptionShipment;
            this.props.onChange(exception);
        };
        this.handleAddComment = async (comment) => {
            this.props.onAddComment(comment);
        };
        this.state = {
            showAddAccessorialModal: false,
            showShipmentModal: false,
            isAdmin: SessionStore.isAdmin(),
        };
    }
    componentDidMount() {
        ShipmentStore.addChangeListener(this.getRefreshedShipment);
        ShipmentStore.addChangeListener(this.handleChange);
        ShipmentStore.addAccessorialChangeListener(this.handleAccessorialError);
    }
    componentWillUnmount() {
        ShipmentStore.removeChangeListener(this.handleChange);
        ShipmentStore.removeChangeListener(this.getRefreshedShipment);
        ShipmentStore.removeAccessorialChangeListener(this.handleAccessorialError);
    }
    updateHold(on_hold) {
        const { _id: exception_id, shipment: { _id: shipment_id }, stop: { _id: stop_id }, exception_type, } = this.props.exception;
        const payload = {
            exception_id,
            shipment_id,
            stop_id,
            exception_type,
            updates: {
                on_hold,
            },
        };
        ExceptionsActionCreators.updateException(payload);
    }
    updateShipment(data) {
        ShipmentsActionCreators.updateShipmentStopWindow(this.props.shipment, this.props.exception.stop, data);
    }
    renderResolveButton() {
        const classNames = classnames({
            button: true,
            'button-green': true,
            'mr-2': true,
            'mt-6': true,
        });
        const { t } = this.props;
        return (React.createElement("button", { type: "button", onClick: () => this.props.onInitiateResolution(this.props.exception), className: classNames }, t('RESOLVE')));
    }
    renderOnHoldButtons() {
        const defaultClass = {
            button: true,
            'button-yellow': true,
            'mr-2': true,
            'mt-6': true,
        };
        const classNames = classnames(defaultClass);
        const disabledClass = classnames(Object.assign(Object.assign({}, defaultClass), { 'opacity-50': true, 'cursor-not-allowed': true }));
        const { t } = this.props;
        return (React.createElement("span", null,
            React.createElement("button", { className: this.props.exception.on_hold ? disabledClass : classNames, type: "button", onClick: () => this.updateHold(true), disabled: this.props.exception.on_hold }, t('PLACE_ON_HOLD')),
            React.createElement("button", { className: this.props.exception.on_hold ? classNames : disabledClass, type: "button", onClick: () => this.updateHold(false), disabled: !this.props.exception.on_hold }, t('CLEAR_HOLD'))));
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement(HeadingDivider, { text: t('JOB_STATUS') }),
            React.createElement(Row, { style: { paddingTop: 5 } },
                React.createElement(Col, { md: 5 },
                    React.createElement(Label, { bsStyle: "danger" }, titleize(t(sluggify(this.props.shipment.status)))))),
            React.createElement(HeadingDivider, { text: t('LOCATION_DETAILS') }),
            React.createElement(Row, { style: { paddingTop: 5 } },
                React.createElement(Col, { md: 3 },
                    React.createElement("span", { style: { color: 'gray' } }, t('ORIGIN'))),
                React.createElement(Col, { md: 9 }, this.props.shipment.origin[0].address)),
            React.createElement(Row, null,
                React.createElement(Col, { md: 3 },
                    React.createElement("span", { style: { color: 'gray' } }, t('DESTINATION'))),
                React.createElement(Col, { md: 9 }, this.props.shipment.destination[0].address)),
            React.createElement(Row, { style: { paddingTop: 5 } },
                React.createElement(Col, { md: 3 },
                    React.createElement("span", { style: { color: 'gray' } }, t('PICKUP'))),
                React.createElement(Col, { md: 9 },
                    moment(this.props.shipment.pickup_after).format('L LT'),
                    " -",
                    ' ',
                    moment(this.props.shipment.pickup_by).format('L LT'))),
            React.createElement(Row, null,
                React.createElement(Col, { md: 3 },
                    React.createElement("span", { style: { color: 'gray' } }, t('DELIVER'))),
                React.createElement(Col, { md: 9 },
                    moment(this.props.shipment.deliver_after).format('L LT'),
                    " -",
                    ' ',
                    moment(this.props.shipment.deliver_by).format('L LT'))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(Button, { bsStyle: "info", style: { marginRight: 10 }, onClick: () => this.setState({ showAddAccessorialModal: true }) }, t('MANAGE_ACCESSORIALS')),
                    React.createElement(Button, { bsStyle: "info", style: { marginRight: 10 }, onClick: () => this.setState({ showShipmentModal: true }) }, t('MANAGE_SHIPMENT_WINDOW')),
                    this.renderResolveButton()),
                React.createElement(AddAccessorialModal, { shipment: this.props.shipment, show: this.state.showAddAccessorialModal, addAccessorial: this.handleAddAccessorial, accessorialError: this.state.accessorialError, removeAccessorial: this.handleRemoveAccessorial, requireApproval: this.props.shipment.shipper.requires_accessorial_approval, onHide: () => this.setState({ showAddAccessorialModal: false }) }),
                React.createElement(ShipmentWindowChange, { stop: this.props.exception.stop, shipment: this.props.shipment, onHideModal: () => this.setState({ showShipmentModal: false }), show: this.state.showShipmentModal, onSave: (data) => this.updateShipment(data) })),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 }, this.renderOnHoldButtons())),
            React.createElement(Row, null,
                React.createElement(CargomaticCard, { className: "mt-6", header: () => React.createElement("h3", { className: "my-0" }, t('DISCUSSION')) },
                    React.createElement(CommentList, { comments: this.props.shipment.comments, onCommentAdd: this.handleAddComment, allowComment: this.state.isAdmin, paginate: true })))));
    }
}
ShipmentDetails.propTypes = {
    shipment: PropTypes.object.isRequired,
    exception: PropTypes.object.isRequired,
    onInitiateResolution: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};
export default withTranslation()(ShipmentDetails);
